import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React from 'react';

const GeneroEstudinatesPieChartPanelControl = ({ mas = 0, fem = 0 }) => {
  const options = {
    chart: {
      type: 'pie',
    },
    title: {
      text: 'Distribución de Estudiantes por Género',
    },
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: true,
          format: '<b>{point.name}</b>: {point.percentage:.1f}%',
        },
      },
    },
    series: [
      {
        name: 'Género',
        data: [
          {
            name: 'Masculino',
            y: mas,
          },
          {
            name: 'Femenino',
            y: fem,
          },
        ],
      },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default GeneroEstudinatesPieChartPanelControl;
